import CONSTANS from '@/util/constants'

export default {
  post (params) {
    return window.axios.post(`${CONSTANS.API_URL}/registrar_usuario`, params)
  },
}
